import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import type { Player } from "../player";
import { PlasmaBall } from "../projectiles/plasmaBall";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class PlasmaGun extends Weapon {
	static key = "PlasmaGun";
	constructor(owner: Player, ammo: number = 5) {
		super(owner, ammo);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH_WHITE;
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.LAUNCHER;
	}

	getMuzzleFlashCount(): number {
		return 15;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_PLASMAGUN));
		const spawnPos = this.owner.xy.add(directionDelta(direction));
		const ball = new PlasmaBall(spawnPos, direction);
		this.shotProjectile(board, ball);
	}

	static deserialize(data: any, owner: Player): PlasmaGun {
		const gun = new PlasmaGun(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
